import { Close } from 'components/lib/icons'
import NakedButton from 'components/lib/NakedButton'
import PresenceAvatar from 'components/PresenceAvatar'
import useActiveSenderId from 'hooks/useActiveSenderId'
import useCloseChat from 'hooks/useCloseChat'
import useRecipientResolution from 'hooks/useRecipientResolution'
import useThemeColors from 'hooks/useThemeColors'
import React from 'react'
import { useSelector } from'react-redux'
import { ConversationId } from 'types/conversation'

import './style.css'

const ChatTakeover = () => {
  const activeConversationId: ConversationId = useSelector(state =>
    state.conversations.activeConversation
  )
  const activeSenderId = useActiveSenderId()
  const { recipient } = useRecipientResolution(activeSenderId)
  const { conversationHeaderTextStyles } = useThemeColors()
  const closeChat = useCloseChat()

  return (
    <div className="drift-widget-active-conversation-header">
      {activeConversationId &&
        <>
          <PresenceAvatar size="SMALL" id={recipient.id}/>
          <h1
            className="drift-widget-recipient-name"
            style={conversationHeaderTextStyles}
          >
            {recipient.name}
          </h1>
        </>
      }

      <NakedButton onClick={closeChat}>
        <Close className="drift-widget-chat-takeover-close" width={16} height={16} />
      </NakedButton>
    </div>
  )
}


export default ChatTakeover
